module.exports = __webpack_public_path__ + "img/SuperMarioLandGameplay.ef702b2e.png";